import type { OrgDashboardApiOrg } from 'modules/orgDashboard/api/types/OrgDashboardApiOrg';
import { postJson } from 'utils/http/postJson';

export function apiCreateOrg(
  // TODO: Fix this the next time the file is edited.
  // oxlint-disable-next-line typescript/no-explicit-any
  orgInfo: Record<string, any>,
): Promise<OrgDashboardApiOrg> {
  return postJson(`/data/website/organizations`, orgInfo).then(
    // @ts-expect-error TS(2345): Argument of type '({ org }: { org: any; }) => any'... Remove this comment to see the full error message
    ({ org }) => org,
  );
}
